'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { CELL_DATA, WIDGET_CONTAINER_DATA, VIRTUAL_CELL_DATA } from 'DesignData/constants/StructuralWidgets';
import { StructuralWidget } from 'DesignData/models/widgets';
/*
 * Structural types native to the platform.
 * Presently there is no API for these. `widget_container` used to be in the
 * presets API.
 */

export default function (state = SeamlessImmutable({
  widgets: {
    [CELL_DATA.type]: new StructuralWidget(CELL_DATA),
    [WIDGET_CONTAINER_DATA.type]: new StructuralWidget(WIDGET_CONTAINER_DATA),
    [VIRTUAL_CELL_DATA.type]: new StructuralWidget(VIRTUAL_CELL_DATA)
  },
  order: [CELL_DATA.type, WIDGET_CONTAINER_DATA.type, VIRTUAL_CELL_DATA.type]
})) {
  return state;
}